import { infrastructuresRepo } from '@/constants/providers';
import { useMutation } from '@tanstack/react-query';
import { DeleteInfrastructureCostDocumentJson } from '../types';

export const useDeleteDocument = () =>
  useMutation<unknown, unknown, DeleteInfrastructureCostDocumentJson>(
    (deleteInfrastructureCostDocument) =>
      infrastructuresRepo.deleteDocument(deleteInfrastructureCostDocument),
  );
